import React, { Fragment } from 'react';
import ReactDOM from "react-dom";


const Backdrop = (props) => {
    return <div className='backdrop_cart'></div>;
}

const ModalOverlay = (props) => {
    return (
    <div className='modal_cart'>
        <div className='content'>{props.children}</div>
    </div>
    );
}

const portalElement = document.getElementById('overlay-root');

const StandardModal = (props) => {
    
    return (
        <Fragment>
            {ReactDOM.createPortal(<Backdrop></Backdrop>, portalElement)}
            {ReactDOM.createPortal(<ModalOverlay>{props.children}</ModalOverlay>, portalElement)}

        </Fragment>
    )
}

export default StandardModal;